import React from 'react';
import { v4 as uuid } from 'uuid';
import { FuelTypography } from '@frete.com/fuel-react';
import { Description } from './styled';

type Props = {
  texts: string[];
};

export const TruckerInformationDescription: React.FC<Props> = ({ texts }) => (
  <Description>
    {texts.map((item) => (
      <FuelTypography key={uuid()} weight="medium" color="neutral-default" size="body-md">
        {item}
      </FuelTypography>
    ))}
  </Description>
);
